// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popularLocationSwiperNavigationNextBtn.swiper-button-disabled,
.popularLocationSwiperNavigationPrevBtn.swiper-button-disabled,
.searchHeaderPrevBtn.swiper-button-disabled,
.searchHeaderNextBtn.swiper-button-disabled,
.viewProfileSwiperNavigationNextBtn.swiper-button-disabled,
.viewProfileSwiperNavigationPrevBtn.swiper-button-disabled,
.RecommendedSwiperNavigationNextBtn.swiper-button-disabled,
.RecommendedSwiperNavigationPrevBtn.swiper-button-disabled,
.mostViewSwiperNavigationNextBtn.swiper-button-disabled,
.mostViewSwiperNavigationPrevBtn.swiper-button-disabled {
    display: none;
}

.homeTypeSwiper .swiper-slide {
    max-width: 270px;
    width: auto;
}

.homeSwiperNavigationBtn {
    position: absolute;
    top: 34%;
    background: var(--background-primary);
    color: var(--primary-foreground);
    width: 46px;
    height: 46px;
    border-radius: 50%;
    text-align: center;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--primary-border);
    padding: 12px;
}

.homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {
    left: -10px;
    box-shadow: -2px 1px 5px var(--primary-box-shadow);
}

.homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {
    right: -10px;
    box-shadow: 2px 1px 5px var(--primary-box-shadow);
}

.homeSwiperNavigationBtn.popularLocationSwiperNavigationPrevBtn,
.homeSwiperNavigationBtn.popularLocationSwiperNavigationNextBtn {
    top: 140px;
}


@media (max-width: 1299px) and (min-width: 1171px) {
    .homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {
        left: 6px;
    }

    .homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {
        right: 6px;
    }
}


/* search page start */


.searchPageSwiperContainer {
    position: relative;
}

.searchPageSwiperNavigationBtn {
    position: absolute;
    top: 50%;
    background: var(--background-primary);
    color: var(--primary-foreground);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    z-index: 1;
    transform: scale(1) translateY(-50%);
    transition: all .2s linear;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--primary-border);
    padding: 12px;
}

.searchPageSwiperNavigationBtn.searchPageSwiperNavigationPrevBtn {
    left: 0;
    box-shadow: -2px 1px 5px var(--primary-box-shadow);
}

.searchPageSwiperNavigationBtn.searchPageSwiperNavigationNextBtn {
    right: 0;
    box-shadow: 2px 1px 5px var(--primary-box-shadow);
}



@media (max-width: 767px) {
    .searchPageSwiperNavigationBtn {
        display: none;
    }
}

/* search page end */

/* whyHost page start */

.whyHostPageSwiperPrevBtn,
.whyHostPageSwiperNextBtn {
    position: static;
    transform: unset;
}

/* whyHost page end */

/* rtl  */

.rtl .homeSwiperNavigationBtn svg,
.rtl .searchPageSwiperNavigationBtn svg {
    transform: rotate(180deg);
}

.rtl .homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {
    left: unset;
    right: -10px;
    box-shadow: 2px 1px 5px var(--primary-box-shadow);
}

.rtl .homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {
    right: unset;
    left: -10px;
    box-shadow: -2px 1px 5px var(--primary-box-shadow);
}

.rtl .searchPageSwiperNavigationBtn.searchPageSwiperNavigationPrevBtn {
    right: 0;
    left: unset;
    box-shadow: 2px 1px 5px var(--primary-box-shadow);
}

.rtl .searchPageSwiperNavigationBtn.searchPageSwiperNavigationNextBtn {
    left: 0;
    right: unset;
    box-shadow: -2px 1px 5px var(--primary-box-shadow);
}

@media (max-width: 1299px) and (min-width: 1171px) {
    .rtl .homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {
        right: 6px;
        left: unset;
    }

    .rtl .homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {
        left: 6px;
        right: unset;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/customSwiper.css"],"names":[],"mappings":"AAAA;;;;;;;;;;IAUI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,iDAAiD;AACrD;;AAEA;;IAEI,UAAU;AACd;;;AAGA;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ;;;AAGA,sBAAsB;;;AAGtB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,oCAAoC;IACpC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,kDAAkD;AACtD;;AAEA;IACI,QAAQ;IACR,iDAAiD;AACrD;;;;AAIA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,oBAAoB;;AAEpB,uBAAuB;;AAEvB;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,qBAAqB;;AAErB,SAAS;;AAET;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;AACrD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kDAAkD;AACtD;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,iDAAiD;AACrD;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;AACJ","sourcesContent":[".popularLocationSwiperNavigationNextBtn.swiper-button-disabled,\n.popularLocationSwiperNavigationPrevBtn.swiper-button-disabled,\n.searchHeaderPrevBtn.swiper-button-disabled,\n.searchHeaderNextBtn.swiper-button-disabled,\n.viewProfileSwiperNavigationNextBtn.swiper-button-disabled,\n.viewProfileSwiperNavigationPrevBtn.swiper-button-disabled,\n.RecommendedSwiperNavigationNextBtn.swiper-button-disabled,\n.RecommendedSwiperNavigationPrevBtn.swiper-button-disabled,\n.mostViewSwiperNavigationNextBtn.swiper-button-disabled,\n.mostViewSwiperNavigationPrevBtn.swiper-button-disabled {\n    display: none;\n}\n\n.homeTypeSwiper .swiper-slide {\n    max-width: 270px;\n    width: auto;\n}\n\n.homeSwiperNavigationBtn {\n    position: absolute;\n    top: 34%;\n    background: var(--background-primary);\n    color: var(--primary-foreground);\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n    text-align: center;\n    transform: translateY(-50%);\n    cursor: pointer;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--primary-border);\n    padding: 12px;\n}\n\n.homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {\n    left: -10px;\n    box-shadow: -2px 1px 5px var(--primary-box-shadow);\n}\n\n.homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {\n    right: -10px;\n    box-shadow: 2px 1px 5px var(--primary-box-shadow);\n}\n\n.homeSwiperNavigationBtn.popularLocationSwiperNavigationPrevBtn,\n.homeSwiperNavigationBtn.popularLocationSwiperNavigationNextBtn {\n    top: 140px;\n}\n\n\n@media (max-width: 1299px) and (min-width: 1171px) {\n    .homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {\n        left: 6px;\n    }\n\n    .homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {\n        right: 6px;\n    }\n}\n\n\n/* search page start */\n\n\n.searchPageSwiperContainer {\n    position: relative;\n}\n\n.searchPageSwiperNavigationBtn {\n    position: absolute;\n    top: 50%;\n    background: var(--background-primary);\n    color: var(--primary-foreground);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    text-align: center;\n    cursor: pointer;\n    z-index: 1;\n    transform: scale(1) translateY(-50%);\n    transition: all .2s linear;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--primary-border);\n    padding: 12px;\n}\n\n.searchPageSwiperNavigationBtn.searchPageSwiperNavigationPrevBtn {\n    left: 0;\n    box-shadow: -2px 1px 5px var(--primary-box-shadow);\n}\n\n.searchPageSwiperNavigationBtn.searchPageSwiperNavigationNextBtn {\n    right: 0;\n    box-shadow: 2px 1px 5px var(--primary-box-shadow);\n}\n\n\n\n@media (max-width: 767px) {\n    .searchPageSwiperNavigationBtn {\n        display: none;\n    }\n}\n\n/* search page end */\n\n/* whyHost page start */\n\n.whyHostPageSwiperPrevBtn,\n.whyHostPageSwiperNextBtn {\n    position: static;\n    transform: unset;\n}\n\n/* whyHost page end */\n\n/* rtl  */\n\n.rtl .homeSwiperNavigationBtn svg,\n.rtl .searchPageSwiperNavigationBtn svg {\n    transform: rotate(180deg);\n}\n\n.rtl .homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {\n    left: unset;\n    right: -10px;\n    box-shadow: 2px 1px 5px var(--primary-box-shadow);\n}\n\n.rtl .homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {\n    right: unset;\n    left: -10px;\n    box-shadow: -2px 1px 5px var(--primary-box-shadow);\n}\n\n.rtl .searchPageSwiperNavigationBtn.searchPageSwiperNavigationPrevBtn {\n    right: 0;\n    left: unset;\n    box-shadow: 2px 1px 5px var(--primary-box-shadow);\n}\n\n.rtl .searchPageSwiperNavigationBtn.searchPageSwiperNavigationNextBtn {\n    left: 0;\n    right: unset;\n    box-shadow: -2px 1px 5px var(--primary-box-shadow);\n}\n\n@media (max-width: 1299px) and (min-width: 1171px) {\n    .rtl .homeSwiperNavigationBtn.homeSwiperNavigationPrevBtn {\n        right: 6px;\n        left: unset;\n    }\n\n    .rtl .homeSwiperNavigationBtn.homeSwiperNavigationNextBtn {\n        left: 6px;\n        right: unset;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
